import PageHeader from "@/components/site/PageHeader";
import SectionHeader from "@/components/site/SectionHeader";
import CompensationCards from "@/components/site/CompensationCards";
import ApplicationForm from "@/components/site/ApplicationForm";
import { Card } from "@/components/ui/card";
import { Factory, Sparkles, HardHat, Clock } from "lucide-react";
import { IMAGES } from "@/lib/brand";

const FOCUS = [
  { icon: Factory, label: "Factory Work" },
  { icon: Sparkles, label: "Housekeeping" },
  { icon: HardHat, label: "Industrial Labor" },
  { icon: Clock, label: "Shift-Based Jobs" },
];

export default function CareersPage() {
  return (
    <div data-testid="careers-page">
      <PageHeader
        eyebrow="Careers at RK Enterprises"
        title="Join a workforce that's respected, supported, and paid on time"
        description="We recruit candidates for factory work, housekeeping, industrial labor, and shift-based jobs — with full benefits and welfare."
        image={IMAGES.industrialWorker}
      />

      {/* Focus areas */}
      <section className="py-16 md:py-24 bg-white">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <SectionHeader
            eyebrow="Recruitment Focus"
            title="We are hiring for"
            description="Open roles across factory operations, housekeeping, industrial labor, and shift-based work."
            testid="careers-focus-header"
          />
          <div className="mt-10 grid grid-cols-2 lg:grid-cols-4 gap-4">
            {FOCUS.map((f, i) => {
              const Icon = f.icon;
              return (
                <Card
                  key={f.label}
                  data-testid={`focus-card-${i}`}
                  className="rk-lift p-6 bg-white border border-[#E2E8F0] rounded-sm text-center"
                >
                  <div className="h-12 w-12 mx-auto grid place-items-center rounded-sm bg-[#1E3A8A]/8 text-[#1E3A8A]">
                    <Icon className="h-6 w-6" />
                  </div>
                  <div className="mt-4 font-display font-bold text-[#0F172A]">
                    {f.label}
                  </div>
                </Card>
              );
            })}
          </div>
        </div>
      </section>

      {/* Compensation */}
      <section className="bg-[#F8FAFC] py-16 md:py-24" id="compensation">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <SectionHeader
            eyebrow="Compensation"
            title="Transparent pay structure"
            description="Daily wages and statutory contributions clearly broken down. Salary credited before the 8th of every month."
            testid="careers-compensation-header"
          />
          <div className="mt-12">
            <CompensationCards />
          </div>
          <p className="mt-6 text-xs text-[#64748B]">
            * Indicative figures. Final compensation is finalized post
            interview based on role, experience, location, and shift.
          </p>
        </div>
      </section>

      {/* Application form */}
      <section className="bg-white py-16 md:py-24" id="apply">
        <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
          <SectionHeader
            eyebrow="Apply Now"
            title="Submit your application"
            description="Fill the form below and our recruitment team will get in touch within 2–3 working days."
            align="center"
            testid="careers-apply-header"
          />
          <div className="mt-12 p-6 sm:p-8 bg-white border border-[#E2E8F0] rounded-sm shadow-sm">
            <ApplicationForm />
          </div>
        </div>
      </section>
    </div>
  );
}
